// Current AyeStore artwork, shared by home, search and AI Zone launchers.
export const APP_LAUNCHER_APPS = [
  { name: "VibeJoo", icon: "", color: "transparent", image: "/static/branding/vibejoo-0dfac542ee7a.png" },
  { name: "AMailMe", icon: "", color: "transparent", image: "/static/branding/amailme-efb8652230bc.png" },
  { name: "OreChat", icon: "", color: "transparent", image: "/static/branding/orechat-d527e919ae51.png" },
  { name: "ADrive", icon: "", color: "transparent", image: "/static/branding/adrive-ca2f3d0d4445.png" },
  { name: "Docs", icon: "", color: "transparent", image: "/static/branding/docs-ae2de0e84976.png" },
  { name: "ANotes", icon: "", color: "transparent", image: "/static/branding/anotes-08cc2fafe478.png" },
];

